<template>
    <zen-message-modal
        :is-open="isOpen"
        :title="`Disconnect ${label}?`"
        icon-variant="danger"
        @close="$emit('close')"
    >
        <p>
            You won't be able to sign in with {{ label }} any more. You can
            connect it again whenever you like.
        </p>
        <template v-slot:buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                :processing="processing"
                processing-label="Disconnecting…"
                @click="$emit('confirm')"
            >
                Disconnect {{ label }}
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
import { socialProviderLabel } from '@/helpers/social-login'

export default {
    name: 'DisconnectSocialIdentityModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        provider: {
            type: String,
            default: null,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm'],
    computed: {
        label() {
            return socialProviderLabel(this.provider)
        },
    },
}
</script>
